import {Box} from '@mui/material'

interface TabPanelProps {
  tab: number
  activeTab: number
  unstyled?: boolean
  children: JSX.Element
}

const TabPanel: React.FC<TabPanelProps> = ({children, activeTab, tab, unstyled}) => {
  if (activeTab !== tab) return <></>

  return (
    <Box sx={unstyled ? {} : styles.panel} hidden={activeTab !== tab}>
      {children}
    </Box>
  )
}

const styles = {
  panel: {
    p: 2,
    minHeight: '55vh',
  },
}

export default TabPanel
